import { PopoverTrigger as OrigPopoverTrigger } from '@chakra-ui/react'

/**
 * A hacky type alias to appease TypeScript given the version of React + Chakra that we're using.
 * See this GitHub [comment](https://github.com/chakra-ui/chakra-ui/issues/5896#issuecomment-1104085557)
 * for more.
 */
export const PopoverTrigger: React.FC<{ children: React.ReactNode }> =
  OrigPopoverTrigger
